// Types
import Reducers from "types/Reducers";
// Model
import { RootState } from "store";

export const selectPlayerData = (state:RootState) => state[Reducers.Rokt].playerData;
export const selectMounted = (state:RootState) => state[Reducers.Rokt].mounted;
